import { Settings, Trash2, X } from "lucide-react"

import { Button } from "@/components/ui/button"

interface BulkSelectionToolbarProps {
  selectedCount: number
  onEdit: () => void
  onDelete: () => void
  onClear: () => void
  isMutating?: boolean
  isDeleting?: boolean
}

export function BulkSelectionToolbar({
  selectedCount,
  onEdit,
  onDelete,
  onClear,
  isMutating = false,
  isDeleting = false,
}: BulkSelectionToolbarProps) {
  if (selectedCount === 0) return null

  return (
    <div
      role="toolbar"
      aria-label="Bulk device actions"
      data-tour="bulk-actions"
      className="flex flex-wrap items-center justify-between gap-2 border-b border-border px-4 py-2.5"
    >
      <div className="flex flex-wrap items-center gap-2">
        <span
          aria-live="polite"
          className="inline-flex items-center rounded-md bg-muted px-2.5 py-1 text-sm font-medium text-foreground"
        >
          {selectedCount} device{selectedCount === 1 ? "" : "s"} selected
        </span>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={onEdit}
          disabled={isMutating}
        >
          <Settings data-icon="inline-start" />
          Edit Configuration
        </Button>
        <Button
          type="button"
          size="sm"
          variant="destructive"
          onClick={onDelete}
          disabled={isMutating}
        >
          <Trash2 data-icon="inline-start" />
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </div>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        onClick={onClear}
        disabled={isMutating}
      >
        <X data-icon="inline-start" />
        Clear selection
      </Button>
    </div>
  )
}
